if (!customElements.get("load-more-button")) {
  class LoadMoreButton extends HTMLElement {
    constructor() {
      super();

      this.text = this.querySelector("[data-load-more-button-text]");
      this.loadIcon = this.querySelector("[data-load-more-button-icon]");
    }

    enable() {
      this.setAttribute("aria-disabled", false);
      this.text.classList.add("hidden");
      this.loadIcon.classList.remove("hidden");
    }
    disable() {
      this.setAttribute("aria-disabled", true);
      this.text.classList.add("hidden");
      this.loadIcon.classList.remove("hidden");
    }
    hide() {
      this.setAttribute("aria-hidden", true);
      this.classList.add("hidden");
    }
  }

  window.customElements.define("load-more-button", LoadMoreButton);
}

if (!customElements.get("load-more")) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.debug = false
        ? console.log.bind(console, "[DEBUG][LoadMore]")
        : () => {};

      this.thisPage = parseInt(this.querySelector("[data-this-page]").value);
      this.totalPages = parseInt(this.querySelector("[data-all-pages]").value);
      this.currentPage = this.thisPage;
      this.nextLink = this.getLink();
      this.contentLoaded = false;

      this.locked = false;

      this.onReachLastPage = eval(this.getAttribute("onReachLastPage"));

      this.triggerOnScroll = true;

      if (this.thisPage >= this.totalPages) {
        this.debug(
          "Load more button loaded but no more pages can be loaded. Disable."
        );
        this.contentLoaded = true;
        this.hide();
      }
	}

    connectedCallback() {
      this.productGrid = document.getElementById("product-grid");

      this.onScrollHandler = debounce(this.onScrollHandler.bind(this), 100);
      window.addEventListener("scroll", this.onScrollHandler);

      this.button = this.querySelector("[data-load-more-button]");
      this.onClick = this.onClickHandler.bind(this);

      this.enable();

      if (this.triggerOnScroll) {
        this.disableButton();
      }

      this.button.addEventListener("click", () => this.disableButton());
    }

    disableButton() {
      this.classList.add("js-loading");
      this.button.disable();
    }

    enableButton() {
      this.classList.remove("js-loading");
      this.button.enable();
    }

    async loadMoreData(url) {
      if (!this.locked) {
        this.locked = true;
        this.debug("Load more items", url);
        try {
          const response = await fetch(url);
          const text = await response.text();

          if (text === null) {
            this.debug("No more data to load");
            return;
          } else {
            this.debug("Got new collection page");
          }

          let htmlObject = document.createElement("html");
          htmlObject.innerHTML = text;

          let nextPageGrid = htmlObject.querySelector("#product-grid");

          const newItems = nextPageGrid.querySelectorAll("li");

          newItems.forEach((item) => {
            item.classList.add("grid__item--fade-in");
            this.productGrid.appendChild(item);
          });

          this.debug(`Add new items (${newItems.length})`);

          this.locked = false;
          if (this.currentPage >= this.totalPages || newItems.length === 0) {
            this.contentLoaded = true;
            this.hide();
          } else {
            this.enable();
          }
        } catch (error) {
          this.locked = false;
          console.error(error);
          this.enable();
        }
      }
    }

    onScrollHandler() {
      if (!this.triggerOnScroll) return;
      if (this.contentLoaded) return;

      const button = this.querySelector("[data-load-more-button]");
      const buttonY = button.getBoundingClientRect().top;

      const thresholdY = Math.max(0, buttonY - window.innerHeight * 2);

      if (window.scrollY >= thresholdY) {
        this.debug("Trigger scroll load more");
        this.triggerLoadMore();
      } else {
        this.debug("No trigger scroll load more, threshold wasn't met");
      }
    }

    onClickHandler() {
      this.debug("Trigger click load more");
      this.triggerLoadMore();
    }

    async triggerLoadMore() {
      this.debug("Trigger load more");
      this.disable();
      this.updateAttributes();
      await this.loadMoreData(this.nextLink);
    }

    getLink() {
      const search = new URLSearchParams(location.search);
      search.set("page", this.currentPage);
      return location.pathname + "?" + search.toString();
    }

    updateAttributes() {
      this.currentPage += 1;
      this.nextLink = this.getLink();
    }

    enable() {
      this.debug("Enable load more");

      window.removeEventListener("scroll", this.onScrollHandler);
      window.addEventListener("scroll", this.onScrollHandler);

      this.addEventListener("click", this.onClick);

      this.enableButton();
    }

    disable() {
      this.debug("Disable load more");

      window.removeEventListener("scroll", this.onScrollHandler);

      this.removeEventListener("click", this.onClick);
      this.disableButton();
    }

    hide() {
      this.debug("Hide load more");
      this.button.hide();

      if (this.onReachLastPage) {
        this.debug("Call the this.onReachLastPage function");
        this.onReachLastPage();
      } else {
        this.debug("No this.onReachLastPage function");
      }
    }
  }

  window.customElements.define("load-more", LoadMore);
}

document.addEventListener("DOMContentLoaded", (event) => {
  const loadMoreElement = document.querySelector("load-more");
  const continueShoppingElement = document.querySelector(
    "[data-collection-continue-shopping]"
  );

  if (!loadMoreElement && continueShoppingElement) {
    continueShoppingElement.style.display = "block";
  }
});
